import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full flex justify-center items-center relative my-[64px] lg:my-[128px] p-4 xl:p-0 xl:pt-[50px]',
);

export const SideBg = w.img(
  'hidden xl:block absolute',
);

export const WrapperContent = w.div(
  'w-[1200px] ',
);

export const WrapperContentH1 = w.h1(
  'font-roboto font-black text-[32px] lg:text-[48px] leading-[56px] tracking-[2px] text-center',
);

export const WrapperContentP = w.p(
  'text-[14px] lg:text-[16px] my-[48px] font-opensans font-normal text-base leading-6 tracking-[0px] text-center max-w-[1100px]',
);

export const CardsBox = w.div(
  'gap-[40px] lg:gap-[48px] flex flex-col flex-wrap  md:flex-row justify-center md:justify-between',
);

export const Card = w.div(
  'border border-[var(--lime-500)] rounded rounded-[16px] w-full lg:w-[228px] h-[112px] md:h-[232px] md:text-center flex md:flex-col items-center lg:justify-between py-[16px] bg-[var(--marine-500)] p-4 gap-[48px] lg:gap-0',
);

export const Cardh6 = w.h6(
  'font-roboto font-bold text-[40px] leading-[48px] tracking-[2px] capitalize mb-[16px]',
);

export const Cardp = w.p(
  'text-[16px] font-roboto font-semibold text-base leading-6 tracking-[1px]',
);